/** @format */

import ContentBlockEditor from '../ContentBlockEditor';
import type { ContentEditorPart, PatchContentPartFn } from 'src/types';

interface ContentEditorBlockBodyContentProps {
  part: ContentEditorPart;
  onPatch: PatchContentPartFn;
}

export default function ContentEditorBlockBodyContent({ part, onPatch }: ContentEditorBlockBodyContentProps) {
  const safeValue = part.type === 'content' && typeof part.text === 'string' ? part.text : '';
  return (
    <ContentBlockEditor
      editorKey={String(part.id)}
      value={safeValue}
      onChange={text => onPatch(part.id, { text })}
    />
  );
}
